export const config = {
  url: process.env.AUTH_URL,
  client: process.env.CLIENT_ID,
  redirect: process.env.REDIRECT_URL,
  scope: "read",
  width: 800,
  height: 400
};